export default [
    {
        path: '/contract-new1',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/contract/contract-new1.vue'),

    },
    {
        path: '/contract-new2',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/contract/contract-new2.vue'),

    },
    {
        path: '/contract-agent',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/contract/contract-agent.vue'),

    },
    {
        path: '/contract-detail',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/contract/contract-detail.vue'),
    },
    {
        path: '/contract-shenp-hhcg',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/contract/contract-shenp-hhcg.vue'),
    },
    {
        path: '/contract-shenpi',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/contract/contract-shenpi.vue'),
    },
    {
        path: '/contract-list',
        component: () => import( '@/views/loud/contract/contract-list.vue'),
        meta: {
            title: '合同列表',
            isTabsPage: true,
            keepAlive: true
        }
    },
    {
        path: '/contractyx-list',
        component: () => import( '@/views/loud/contract/contractyx-list.vue'),
        meta: {
            title: '合同列表(元析)',
            isTabsPage: true,
            keepAlive: true
        }
    },
	{
		//新建合同弹窗
		path: '/createHetong',
		component: () => import( '@/views/loud/contract/createHetong.vue'),
        meta: {
            title: '新建合同',
            isTabsPage: true,
            keepAlive: true
        }
	},
    {
        path: '/contract-update',
        // which is lazy-loaded when the route is visited.
         component: () => import( '@/views/loud/contract/contract-update.vue'),
       // component: resolve => require(['@/views/loud/contract/contract-update.vue'], resolve),
    },
    {
        path: '/contract-update-view',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/contract/contract-update-view.vue'),
    },
    {
        path: '/contract-list-agent',
        component: () => import( '@/views/loud/contract/contract-list-agent.vue'),
        meta: {
            title: '合同列表',
            isTabsPage: false,
            keepAlive: false
        }
    },

    {
        path: '/contract-agent-see',
        component: () => import( '@/views/loud/contract/contract-agent-see.vue'),
        meta: {
            title: '查看合同',
            isTabsPage: false,
            keepAlive: false
        }
    },
    {
        path: '/contract-hhxm-shenpi',
        component: () => import( '@/views/loud/contract/contract-hhxm-shenpi.vue'),
        meta: {
            title: '查看合同',
            isTabsPage: false,
            keepAlive: false
        }
    },
    {
        path: '/contract-hhxm-detaili',
        component: () => import( '@/views/loud/contract/contract-hhxm-detaili.vue'),
        meta: {
            title: '查看合同',
            isTabsPage: false,
            keepAlive: false
        }
    },
    {
        path: '/contract-xs-detaili',
        component: () => import( '@/views/loud/contract/contract-xs-detaili.vue'),
        meta: {
            title: '查看合同',
            isTabsPage: false,
            keepAlive: false
        }
    },

    {
        path: '/contract-agent-add',
        component: () => import( '@/views/loud/contract/contract-agent-add.vue'),
        meta: {
            title: '查看合同',
            isTabsPage: false,
            keepAlive: false
        }
    },

]
